import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'

@customElement('e-cluster')
export class Cluster extends LitElement {
    @property({ type: String }) justify = 'flex-start'
    @property({ type: String }) align = 'flex-start'
    @property({ type: String }) space = 'var(--s1)'
    @property({ type: Boolean }) nowrap = false

    static styles = css`
        :host {
            display: block;
        }

        .cluster {
            display: flex;
            flex-wrap: var(--cluster-wrap, wrap);
            gap: var(--cluster-space, var(--s1));
            justify-content: var(--cluster-justify, flex-start);
            align-items: var(--cluster-align, flex-start);
        }
    `

    updated(changedProperties: Map<string, unknown>) {
        if (changedProperties.has('space')) {
            this.style.setProperty('--cluster-space', this.space)
        }
        if (changedProperties.has('justify')) {
            this.style.setProperty('--cluster-justify', this.justify)
        }
        if (changedProperties.has('align')) {
            this.style.setProperty('--cluster-align', this.align)
        }
        if (changedProperties.has('nowrap')) {
            this.style.setProperty('--cluster-wrap', this.nowrap ? 'nowrap' : 'wrap')
        }
        super.updated(changedProperties)
    }

    render() {
        return html`
            <div class="cluster">
                <slot></slot>
            </div>
        `
    }
}
